const SriLankaColors = {
  Buddhist: "#FFBD29",
  Sinhala: "#8C1539",
  Tamil: "#EA7500",
  Muslim: "#01544E",
};

export default SriLankaColors;
